// src/utils/api.js

import axios from 'axios';

const baseURL = process.env.VUE_APP_BASE_URL;

export const fetchCustomer = async (param='customer') => {
    try {
        const response = await axios.get(`${baseURL}?action=readCustomer&type=${param}`);
        if (response && response.data && response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error(response.data.message || 'Failed to fetch customers');
        }
    } catch (error) {
        throw new Error('Network Error: ' + (error.message || error));
    }
};

export const fetchUsers = async (param='customer') => {
    try {
        const response = await axios.get(`${baseURL}?action=readUser&type=${param}`);
        if (response && response.data && response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error(response.data.message || 'Failed to fetch users');
        }
    } catch (error) {
        throw new Error('Network Error: ' + (error.message || error));
    }
};

export const fetchCustomerAccess = async (param='customer') => {
    try {
        const response = await axios.get(`${baseURL}?action=readCustomerAccess&type=${param}`);
        if (response && response.data && response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error(response.data.message || 'Failed to fetch customer access list');
        }
    } catch (error) {
        throw new Error('Network Error: ' + (error.message || error));
    }
};

